var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("h2", { staticClass: "title" }, [_vm._v("Setting Project Email")]),
      _c("div", { staticClass: "is-clearfix" }),
      _vm._l(_vm.dataStatus, function(item) {
        return _c("div", { key: item.projectStatus, staticClass: "columns" }, [
          _c("div", { staticClass: "column is-2" }, [
            _vm._v(
              "\n            " + _vm._s(item.projectStatus) + " :\n        "
            )
          ]),
          _c("div", { staticClass: "column is-6" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: item.email,
                  expression: "item.email"
                }
              ],
              staticClass: "textarea",
              attrs: {
                type: "text",
                rows: "2",
                placeholder: "example@musubi.co.th,example2@musubi.co.th"
              },
              domProps: { value: item.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(item, "email", $event.target.value)
                }
              }
            })
          ])
        ])
      }),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column is-2" },
          [
            _c("isButton", {
              ref: "btnCreate",
              attrs: { onClick: _vm.updateData, title: "Save" }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b5faf298", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5faf298","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/admin/email/setting.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-b5faf298","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/admin/email/setting.vue
// module chunks = 37